module.exports = __webpack_public_path__ + "static/img/white-logo.9c5c23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/white-logo.png
// module id = U2/1
// module chunks = 18